import styled from "styled-components"
import { Inscription, Main } from "../shared/StylePage"
import peopl0 from '../img/People/0 Журавлев.jpg'
import peopl1 from '../img/People/1 Ходырев.jpg'
import peopl2 from '../img/People/2 Гавриков.jpg'
import peopl3 from '../img/People/3 Петров.jpg'
import peopl4 from '../img/People/4 шахтина.jpg'
import peopl5 from '../img/People/5 Шувалов.jpg'
import peopl6 from '../img/People/6 Галиахметов.jpg'
import peopl7 from '../img/People/7 каманцев.jpg'
import peopl8 from '../img/People/8 лихачева.jpg'
import peopl9 from '../img/People/9 Чирков.jpg'
import peopl10 from '../img/People/10 выдрин.jpg'
import peopl11 from '../img/People/11 евсеев.jpg'
import peopl12 from '../img/People/12 жуйкова.jpg'
import peopl13 from '../img/People/13 зосимова.jpg'
import peopl14 from '../img/People/14 пермяков.jpg'
import peopl15 from '../img/People/15 серов.jpg'
import peopl16 from '../img/People/16 созыкина.jpg'
import peopl17 from '../img/People/17 чеснокова.jpg'
import peopl18 from '../img/People/18 чурина.jpg'
import peopl19 from '../img/People/19 шихарева.jpg'

const FormGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(5,1fr);
    padding-top: 52px;
    gap: 15px;
    @media(width < 1110px){
        grid-template-columns: repeat(2,1fr);
        
    }
    @media(width <= 828px){
        grid-template-columns: repeat(1,1fr);
        justify-items: center;
    }
`

const FormPeople = styled.div`
    display: flex;
    flex-direction: column;
    max-width: 270px;
`
const Img = styled.img`
    width: 197px;
    height: 197px;
    border: 0px solid black;
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    object-fit: cover;
    object-position: 50% 10%;
`
const TopText = styled.p`
    margin: 0 0;
    padding-top: 43px;
    color: #FFFFFF;
    font-size: 19px;
`
const LowerText = styled.p`
    margin: 0 0;
    font-size: 13px;
`
export const People = () =>{
    const people = [
        {
            img: peopl0,
            FCS: 'Журавлев Александр Андреевич',
            status: 'Руководитель Администрации Главы и Правительства Удмуртской Республики'
        },
        {
            img: peopl1,
            FCS: 'Ходырев Даниил Павлович',
            status: 'заместитель Руководителя Администрации Главы и Правительства Удмуртии'
        },
        {
            img:peopl2,
            FCS: 'Гавриков Дмитрий Александрович',
            status: 'начальник Управления по развитию гражданских инициатив Администрации Главы и Правительства Удмуртии'
        },
        {
            img:peopl3,
            FCS: 'Петров Эдуард Степанович',
            status: 'министр национальной политики Удмуртии'
        },
        {
            img:peopl4,
            FCS: 'Шахтина Юлия Германовна',
            status: 'директор Дома Дружбы народов Удмуртии, председатель Общественной палаты Удмуртии'
        },
        {
            img:peopl5,
            FCS: 'Сергей Борисович Шувалов',
            status: 'член Общественной палаты Российской Федерации'
        },
        {
            img:peopl6,
            FCS: 'Галиахметов Раиль Ахсанович',
            status: 'заместитель председателя Общественной палаты Удмуртии, проректор по стратегическим коммуникациям ФГБОУ ВО «ИжГТУ имени М.Т.Калашникова»'
        },
        {
            img:peopl7,
            FCS: 'Каманцев Владимир Анатольевич',
            status: 'заместитель председателя Общественной палаты Удмуртии, заслуженный мастер спорта, серебряный призер Паралимпийских Игр'
        },
        {
            img:peopl8,
            FCS: 'Лихачева Ольга Михайловна',
            status: 'заместитель председателя Общественной палаты Удмуртии, заместитель Председателя Совета регионального отделения Общероссийского общественно-государственного движения детей и молодежи «Движение первых» Удмуртской Республики'
        },
        {
            img:peopl9,
            FCS: 'Чирков Степан Владимирович',
            status: 'заместитель председателя Общественной палаты Удмуртии, руководитель Удмуртского регионального отделения Молодежной общероссийской общественной организации «Российские Студенческие Отряды»'
        },

        {
            img:peopl10,
            FCS: 'Выдрин Дмитрий Борисович',
            status: 'член Общественной палаты Удмуртии, руководитель регионального отделения ВОО «Союз отцов» Удмуртской Республики, руководитель АНО "Центр развития и защиты детей "Родительский Комитет Удмуртии"'
        },
        {
            img:peopl11,
            FCS: 'Евсеев Александр Николаевич',
            status: 'председатель комиссии Общественной палаты Удмуртии ЖКХ, безопасности, общественному контролю, председатель Общественной организации потребителей услуг ЖКХ «Объединение советов домов Удмуртской Республики»'
        },
        {
            img:peopl12,
            FCS: 'Жуйкова Алина Владимировна',
            status: 'заместитель директора Дома Дружбы народов, член Регионального отделения Общероссийской общественно-государственной организации «Ассамблея народов России» Удмуртской Республики'
        },
        {
            img:peopl13,
            FCS: 'Зосимова Ольга Викторовна',
            status: 'председатель комиссии Общественной палаты Удмуртии по просвещению, развитию образования, науки и культуры, директор АНО «Школа-кроха»'
        },
        {
            img:peopl14,
            FCS: 'Пермяков Сергей Павлович',
            status: 'председатель комиссии Общественной палаты Удмуртии по экологии и развитию местных сообществ, директор Удмуртской Ассоциации переработчиков отходов'
        },

        {
            img:peopl15,
            FCS: 'Серов Роман Дмитриевич',
            status: 'координатор Регионального корпуса этноволонтеров Удмуртии'
        },
        {
            img:peopl16,
            FCS: 'Созыкина Мария Сергеевна',
            status: 'председатель комиссии Общественной палаты Удмуртии по экономическому развитию и предпринимательству, руководитель Удмуртской республиканской молодежной общественной организации «Атмосфера»'
        },


        {
            img:peopl17,
            FCS: 'Чеснокова Людмила Валерьевна',
            status: 'председатель комиссии Общественной палаты Удмуртии по социальной политике, здравоохранению и спорту, директор Реабилитационного центра «Адели»'
        },
        {
            img:peopl18,
            FCS: 'Чурина Татьяна Владимировна',
            status: 'игропрактик, координатор проекта «Родина – значит вместе!»'
        },

        {
            img:peopl19,
            FCS: 'Шихарева Ирина Юрьевна',
            status: 'председатель комиссии Общественной палаты Удмуртии по развитию НКО, добровольчеству, патриотическим проектам и молодежной политике, руководитель проектов по работе с выпускниками проекта «Мастерская новых медиа» АНО «Россия - страна возможностей»'
        }
    ]
    return(
        
        <Main color="#E3022D" padtop='29' padbott='101' id="s4" wrap='wrap'>
            <Inscription size='39' weight='600' color='#FFFFFF'>Эксперты</Inscription>
            <FormGrid>
                {
                    people.map((e) =>{
                        return(
                            <FormPeople>
                                <Img src={e.img}/>
                                <TopText>{e.FCS}</TopText>
                                <LowerText>{e.status}</LowerText>
                            </FormPeople>
                        )
                    })
                }
            </FormGrid>
        </Main>
    )
}